import getMarkersWithDescendentsForMarkers from '../getMarkersWithDescendentsForMarkers';

/**
 * Gets an array of all BookDocument objects associated with any BookMarker object in an array of BookMarker objects
 *
 * @method getDocumentsForMarkers
 * @param {Array<BookMarker>} markers
 * @returns {Array<BookDocument>} array of unique BookDocument objects
 */
const getDocumentsForMarkers = (markers) => {
  markers = getMarkersWithDescendentsForMarkers(markers);

  return [
    ...new Set(markers.map((marker) => marker.documentsForOffline).flat()),
  ];
};

export default getDocumentsForMarkers;
